import axiosInstance from "../../axiosInstance";

const BASE_URL = "/elearning/employee-course-access";

export const getCourseAssignEmployees = async (branchId, filters = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/employees`, {
    params: { branch_id: branchId, ...filters },
  });
  return {
    employees: res.data?.employees || [],
    total: Number(res.data?.total || 0),
    page: Number(res.data?.page || 1),
    size: Number(res.data?.size || 40),
  };
};

export const getAssignableCoursesForBranch = async (branchId) => {
  const res = await axiosInstance.get(`${BASE_URL}/assignable-courses`, {
    params: { branch_id: branchId },
  });
  return res.data?.courses || [];
};

export const getEmployeeCourseAccess = async (employeeId) => {
  const res = await axiosInstance.get(`${BASE_URL}/${employeeId}`);
  return res.data;
};

export const updateEmployeeCourseAccess = async (employeeId, courseIds) => {
  const res = await axiosInstance.put(`${BASE_URL}/${employeeId}`, {
    course_ids: courseIds,
  });
  return res.data;
};

/** Nhập Excel gán khóa học hàng loạt theo chi nhánh. mode: merge | replace */
export const importEmployeeCourseAccessFromExcel = async (
  file,
  { branchId, mode = "merge" } = {}
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("branch_id", branchId);
  formData.append("mode", mode);
  const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
